import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-entry-point',
  template: `<div>Загрузка...</div>`,
  standalone: true,
})
export class EntryPointComponent implements OnInit {
  private readonly router = inject(Router);

  ngOnInit(): void {
    // Если мы дошли до этого компонента, значит все гарды прошли успешно
    // Просто редиректим на главную страницу
    this.router.navigate(['/cabinet/all/load/list']);
  }
}
